module.exports = __webpack_public_path__ + "img/aqfh-img-84.14453a19.png";